import { actionTypes } from "../constants/action-types"
import { user } from '../../helpers/requests'

const dummySections = () => {

    let dummyData = [{
        asp: 5119.6581,
        atv: 10239.3162,
        conversion: 1,
        emp_id: "623d754f9d6ad7d251b81544",
        ipt: 20,
        minutes: 47.45,
        net_sale: 10239.3162,
        sec_id: "6238746bf63c815bab7642fb",
        traffic: 121,
        transaction: 1,
        units: 2
    },

        , {
        asp: 3644.9175846153844,
        atv: 4738.39286,
        conversion: 0,
        emp_id: "623d75f99d6ad7d251b81564",
        ipt: 1.3,
        minutes: 500,
        net_sale: 47383.9286,
        sec_id: "6238732af63c815bab7640b3",
        traffic: 58,
        transaction: 10,
        units: 13
    }, {
        asp: 4068.452388888889,
        atv: 5230.867357142857,
        conversion: 230,
        emp_id: "623d75fa9d6ad7d251b81565",
        ipt: 1.2857142857142858,
        minutes: 40,
        net_sale: 36616.0715,
        sec_id: "623b073f6043c1508cec1cd8",
        traffic: 20,
        transaction: 7,
        units: 9,
    }, {
        asp: 2708.1807000000003,
        atv: 2708.1807000000003,
        conversion: 850,
        emp_id: "623d75fc9d6ad7d251b81566",
        ipt: 1,
        minutes: 560,
        net_sale: 8124.542100000001,
        sec_id: "6238751df63c815bab764437",
        traffic: 59,
        transaction: 3,
        units: 3
    }
    ]

    return dummyData

}




const initialState = {
    sectionOfEmploye: [],
    floor: null,
    employee: [],
    graphOfEmploye : [],
    graphLoader : false


}

export const employeActivity = (state = initialState, { type, payload = {} }) => {
    switch (type) {
        case actionTypes.GET_SECTIONS_EMPLOYEE:
            if (user.name === "Saphhire") {
                console.log('payload', payload);
                return {
                    ...state, sectionOfEmploye: payload
                }
            }
            if (!payload.length) {
                if (user.name != "Saphhire") {
                    return {
                        ...state, sectionOfEmploye: dummySections()
                    }
                }
            }
            else {
                return {
                    ...state, sectionOfEmploye: dummySections()
                }
            }
        case actionTypes.GET_GRAPH_OF_EMPLOYEE_ACTIVITY : 
         return {...state, graphOfEmploye : payload}
         
        case actionTypes.SET_FLOOR:
            return {
                floor: payload
            }
        case actionTypes.SET_EMPLOYEE:
            if (payload.length) {
                return {
                    ...state, employee: payload
                }
            }
        case actionTypes.EMP_ACT_GRAPH_LOADER : 
            return {...state, graphLoader : payload}
        default:
            return state
    }
}
